import React, {useState, useRef, useEffect} from 'react';
//import './TeamCard.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

export default function AppAdminCard({show_display}) 
{
    const { num_display_columns, setMainColumnDisplayType, app_admin_users_list, app_admin_public_teams_list } = useCTAL();

    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_users] = useState('users'); 
    const [img_teams] = useState('team'); 
    
    const [img_users_file, setImgUsersFile] = useState(img_loc + img_users + img_sel + img_ext); 
    const [img_teams_file, setImgTeamsFile] = useState(img_loc + img_teams + img_ext); 

    const [sel_icon_changed, setSelIconChanged] = useState(false); 

    const [current_display_type, setCurrentDisplayType] = useState("users-list"); 
        
    const [app_admin_txt]                       = useState("Application Admin"); 
    const [users_txt, setUsersTxt]              = useState("? users, "); 
    const [public_teams_txt, setPublicTeamsTxt] = useState("? public teams"); 
    
    const [users_style_class, setUsersStyleClass]              = useState("card-link-normal"); 
    const [public_teams_style_class, setPublicTeamsStyleClass] = useState("card-link-normal"); 

    const initRef = useRef("");
    const initMemberRef = useRef("");
    
    const tooltipRef_users   = useRef(null);
    const tooltipRef_teams   = useRef(null);

    useEffect(() =>
    {
        if (sel_icon_changed) show_display(current_display_type);
    }, [current_display_type]);

    useEffect(() =>
    {
        if (app_admin_users_list.length <= 0) return;

        setUsersTxt( (app_admin_users_list.length == 1 ? `${app_admin_users_list.length} user, ` : `${app_admin_users_list.length} users, `)   );
        setUsersStyleClass ( (app_admin_users_list.length > 0 ? "card-link-highlight" : "card-link-normal") );
    }, [app_admin_users_list]);

    useEffect(() =>
    {
        if (app_admin_public_teams_list.length <= 0) return;

        setPublicTeamsTxt( (app_admin_public_teams_list.length == 1 ? `${app_admin_public_teams_list.length} team` : `${app_admin_public_teams_list.length} teams`)   );
        setPublicTeamsStyleClass ( (app_admin_public_teams_list.length > 0 ? "card-link-highlight" : "card-link-normal") );
    }, [app_admin_public_teams_list]);

    if ((initRef.id != "init-done") && (tooltipRef_users.current))
    {
        initRef.id = "init-done";

        const tooltip_users  = new window.bootstrap.Tooltip(tooltipRef_users.current, { container: 'body', trigger: 'hover' });
        const tooltip_teams  = new window.bootstrap.Tooltip(tooltipRef_teams.current, { container: 'body', trigger: 'hover' });
        
        return () => {
            tooltip_users.dispose();
            tooltip_teams.dispose();
        };
    }

    const change_display = (display_type) => {
        if (display_type == current_display_type) return; //No Change
        
        setSelIconChanged(false);
        setImgUsersFile(img_loc + img_users + img_ext);
        setImgTeamsFile(img_loc + img_teams + img_ext);

        switch (display_type)
        {
            case "users-list"       : setImgUsersFile(img_loc + img_users + img_sel + img_ext); break;
            case "public-teams-list": setImgTeamsFile(img_loc + img_teams + img_sel + img_ext); break;
        }
        
        setSelIconChanged(true);
        setCurrentDisplayType(display_type);
    } 
   
    var user_link_icon;
    if (num_display_columns < 3)
        user_link_icon = <a class="me-3" href="#"><img class="card-icon" src="./images/user.svg" alt="user-display" border="0" onClick={ () => setMainColumnDisplayType("User") }/></a>;
    else
        user_link_icon = <></>;

    return (
        <>
            <div class="card mt-0 mb-1">
                <div id="team-card-body" class="card-body">
                    <h5 class="card-title text-center">{app_admin_txt}</h5>
                    <div class="row">
                        <div class="col-9 text-start">
                            <small>
                                <span class={users_style_class}       ><a href="#" onClick={ () => change_display("users-list") }>{users_txt}</a></span>
                                <span class={public_teams_style_class}><a href="#" onClick={ () => change_display("public-teams-list") }>{public_teams_txt}</a></span>
                            </small>
                        </div>
                        <div class={"col-3 text-end"}>
                            <small>

                            </small>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-1 text-start">
                            {user_link_icon}
                        </div>
                        <div class="col text-end">
                            <a href="#" ref={tooltipRef_users}  data-bs-toggle="tooltip" data-bs-title="App Users"    data-bs-delay="750"><img class="card-icon" src={img_users_file} alt="users" border="0" onClick={ () => change_display("users-list") }/></a>
                            <a href="#" ref={tooltipRef_teams}  data-bs-toggle="tooltip" data-bs-title="Public Teams" data-bs-delay="750"><img class="card-icon" src={img_teams_file} alt="teams" border="0" onClick={ () => change_display("public-teams-list") }/></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

/*
                                <span class={stg_class}><a href="#" onClick={ () => change_display("short-term-goals") }>{short_term_goal_txt}</a></span>

*/